"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryListSection = void 0;
var SearchSuggestionClick = _interopRequireWildcard(require("@ori-events/search-suggestion-click"));
var _analyticsData = require("@ori/analytics-data");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _utils = require("../../../../utils");
var _styles = require("../../styles");
var _SearchPreviewQuerie = require("../SearchPreviewQuerie");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const QueryListSection = ({
  title,
  items,
  query,
  showIcon = true,
  withPaddingBottom = false
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const onQuerieClick = (0, _react.useCallback)((querie, position, url) => () => {
    window.dispatchEvent(new CustomEvent(SearchSuggestionClick.Name, {
      detail: {
        itemData: {
          target: url ?? '',
          localBannerTitle: querie,
          media: []
        },
        itemType: _analyticsData.ContentType.PopularQuery,
        searchQuery: query,
        placement: _analyticsData.Placement.TopNavigationSearchSuggestions,
        position
      }
    }));
    if (url) {
      (0, _utils.goToPage)(url);
    }
  }, [query]);
  if (!items.length) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
    withPaddingBottom: withPaddingBottom,
    "data-testid": getTestId(_constants.QUERY_LIST_SECTION),
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SectionLabel, {
      variant: "caption",
      children: title
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.Queries, {
      children: items.map(({
        text,
        url
      }, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreviewQuerie.SearchPreviewQuerie, {
        text: text,
        showIcon: showIcon,
        searchPhrase: query,
        onClick: onQuerieClick(text, index, url)
      }, text))
    })]
  });
};
exports.QueryListSection = QueryListSection;
//# sourceMappingURL=QueryListSection.js.map